import { Tooltip, TooltipProps } from '@mantine/core';

interface Props extends Partial<Omit<TooltipProps, 'label'>> {
  title: string;
  show?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

function CustomTooltip(props: Props) {
  const {
    show = true,
    title,
    children,
    position = 'bottom',
    withArrow = true,
    color = 'var(--neutral-n-800)',
    radius = '8px',
    offset,
    multiline,
    width,
    transitionProps,
    opened,
    disabled,
    style = props?.style || {},
    className = props?.className || '',
    ...rest
  } = props;

  if (!show || disabled) {
    return <div>{children}</div>;
  }

  return (
    <Tooltip
      withArrow={withArrow}
      label={title}
      position={position}
      color={color}
      radius={radius}
      offset={offset}
      multiline={multiline}
      width={width}
      transitionProps={transitionProps}
      opened={opened}
      style={{
        fontFamily: 'Poppins',
        ...style,
      }}
      className={className}
      {...rest}
    >
      {children}
    </Tooltip>
  );
}

export default CustomTooltip;
